var googleDataLayer = {
    _dataLayer: null,

    init: function () {
        if (typeof (dataLayer) == 'undefined' || dataLayer == null || typeof (dataLayer) != 'object') {
            console.error("Google datalayer object is not available. No data layer transaction can take place");
            return false;
        } else {
            this._dataLayer = dataLayer
            return true;
        }
    },

    presentedAgeGate: function () {
        if (this.init()) {
            console.log("presentedAgeGate");
            return this._dataLayer.push(
                {
                    event: "age_gate_shown"
                });
        }
    },

    passedAgeGate: function (selectedCountry, selectedYear) {
        if (this.init()) {
            let data = {
                country: selectedCountry,
                year: selectedYear
            };
            console.log("passedAgeGate %o", data);
            return this._dataLayer.push(
                {
                    event: "age_gate_pass",
                    age_gate_data: data

                });
        }
    },

    failedAgeGate: function (selectedCountry, selectedYear, errorReason) {
        if (this.init()) {
            let data = {
                country: selectedCountry,
                year: selectedYear,
                fail_reason: errorReason
            };
            console.log("failedAgeGate %o", data);
            return this._dataLayer.push(
                {
                    event: "age_gate_fail",
                    age_gate_data: data
                });
        }
    },

    newsletterSignup: function (selectedInterest) {
        if (this.init()) {
            console.log("newsletterSignup %o", selectedInterest);
            return this._dataLayer.push(
                {
                    event: "newsletter_signup",
                    newsletter_interest: selectedInterest
                });
        }
    },

    contactFormSignup: function (selectedInterest) {
        if (this.init()) {
            //let data = {
            //    newsletter_interest: selectedInterest
            //};
            console.log("contactFormSignup %o", selectedInterest);
            return this._dataLayer.push(
                {
                    event: "contact_form_submit",
                    contact_form_preference: selectedInterest
                });
        }
    },
    viewItem: function (product) {
        var d = product.split(',');
        if (this.init()) {
            let itemData = [{
                item_name: d[0],
                item_id: d[1],
                price: d[2],
                item_brand: d[3],
                item_category: d[4],
                item_variant: d[5],
                quantity: d[6],
                coupon: d[8]
            }];
            let data = {
                currency: d[7],
                value: d[2],
                items: itemData
            };
            console.log("viewItem %o", data);
            return this._dataLayer.push(
                {
                    event: "view_item",
                    ecommerce: data
                });
        }
    },
    addToCart: function (product) {
        var d = product.split(',');
        if (this.init()) {
            let itemData = [{
                item_name: d[0],
                item_id: d[1],
                price: d[2],
                item_brand: d[3],
                item_category: d[4],
                item_variant: d[5],
                quantity: d[6],
                coupon: d[8]
            }];
            let data = {
                currency: d[7],
                value: d[2],
                items: itemData
            };
            console.log("addToCart %o", data);
            return this._dataLayer.push(
                {
                    event: "add_to_cart",
                    ecommerce: data
                });
        }
    },
    registerInterest: function (interestPreference, interestCampaign, keepMeUpdated) {
        if (this.init()) {
            console.log("registerInterest %o", interestPreference, interestCampaign, keepMeUpdated);

            return this._dataLayer.push(
                {
                    event: "register_interest",
                    interest_preference: interestPreference,
                    interest_campaign: interestCampaign,
                    newsletter: keepMeUpdated
                });
        }
    },
    beginCheckout: function (orderDetails) {

        var currency = orderDetails["currency"];
        var value = orderDetails["value"];
        var items = orderDetails["items"];
        var inviteCampaign = orderDetails["inviteCampaign"]; 

        if (this.init()) {
            let data = {
                currency: currency,
                value: value,
                coupon: inviteCampaign,
                items: items
            };
            console.log("beginCheckout %o", data);
            return this._dataLayer.push(
                {
                    event: "begin_checkout",
                    ecommerce: data
                });
        }
    },
    completeCheckout: function (purchaseInfo) {
        var purchaseObject = purchaseInfo;
        if (this.init()) {

            var itemArray = purchaseObject["lineItems"];
            let itemsData = [];

            var campaignId = "";

            itemArray.forEach((item) => {

                item.customAttributes.forEach((attr) => {
                    if (attr.Key == 'campaignId') {
                        campaignId = attr.Value
                    }
                });

                let itemDetails = {
                    item_name: item["name"],
                    item_id: item["name"],
                    coupon: campaignId,
                    quantity: item["quantity"],
                    price: item["discountedTotalSet"]["presentmentMoney"]["amount"]
                };

                itemsData.push(itemDetails);
            });

            let data = {
                'transaction_id': purchaseObject.name,
                currency: purchaseObject.netPaymentSet.presentmentMoney.currencyCode,
                value: purchaseObject.netPaymentSet.presentmentMoney.amount,
                coupon: campaignId,
                items: itemsData
            };
            console.log("completeCheckout %o", data);
            return this._dataLayer.push(
                {
                    event: "purchase",
                    ecommerce: data
                });
        }
    },
    inviteSuccess: function () {

        if (this.init()) {
            console.log("inviteSuccess");
            return this._dataLayer.push(
                {
                    'event': 'invite_link_success'
                });
        }
    },
    inviteFailure: function (reason) {

        if (this.init()) {
            console.log("inviteFailure %o", reason);
            return this._dataLayer.push(
                {
                    'event': 'invite_link_fail',
                    'fail-reason': reason
                });
        }
    }
};